// client/src/hooks/usePageTracking.js
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { fetchJson } from '../utils/fetchJson';

// Debounce: don't track the same path more than once per 5 seconds
const DEBOUNCE_MS = 5000;

export default function usePageTracking() {
  const location = useLocation();
  const lastTracked = useRef({ path: '', time: 0 });

  useEffect(() => {
    const path = location.pathname;
    const now = Date.now();

    // Skip if same path tracked recently
    if (path === lastTracked.current.path && now - lastTracked.current.time < DEBOUNCE_MS) {
      return;
    }

    lastTracked.current = { path, time: now };

    // Fire-and-forget — don't block rendering
    fetchJson('/api/page-visits/track', {
      method: 'POST',
      body: { pagePath: path },
    }).catch(() => {
      // Silently ignore tracking errors
    });
  }, [location.pathname]);
}
